/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import clsx from 'clsx';

import Button from './DeprecatedButton';
import Spinner from '../Spinner';

interface Props {
  children?: React.ReactNode;
  active?: boolean;
  // Prefer data-testid for new changes as @testing-library/react has a shortcut
  'data-testid'?: string;
  dataFor?: string;
  dataTip?: string;
  disabled?: boolean;
  modifierClassName?: string;
  stretch?: boolean;
  variant: 'danger' | 'primary' | 'secondary' | 'borderless' | 'selected';
  size?: 'small' | 'medium' | 'large';
  onClick?(event: React.FormEvent<HTMLFormElement>): any;
  submitting: boolean;
  type?: 'submit' | 'button';
}

/**
 * @deprecated replace with ui/SubmitButton
 */
export default class SubmitButton extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    type: 'submit',
  };

  render() {
    const {
      children,

      disabled,
      modifierClassName: modifierClassNameFromProps,
      size,
      submitting,
      stretch,
      type,
      variant,
      onClick,
    } = this.props;

    const modifierClassName = clsx('SubmitButton', modifierClassNameFromProps, {
      'is-submitting': submitting,
    });

    return (
      <Button
        data-testid={this.props['data-testid']}
        disabled={disabled || submitting}
        modifierClassName={modifierClassName}
        size={size}
        stretch={stretch}
        type={type}
        variant={variant}
        onClick={onClick as any}
      >
        {submitting && <Spinner contextClassName="SubmitButton-spinner" />}
        <div className="SubmitButton-text">{children}</div>
      </Button>
    );
  }
}
